import { fk, attr, oneToOne } from 'redux-orm';
import {
    OBJECT_TYPE_SEAT,
    SEAT_TYPE_CIRCLE,
    SEAT_PURCHASE_STATUS_FREE,
} from '%paysera_seat_selection/js/seatSelection/config/constants';
import singleLabel from '../defaults/singleLabel';
import BaseModel from './BaseModel';
import polygon from '../defaults/polygon';

class Seat extends BaseModel {
    static modelName = 'Seat';

    static fields = {
        ...BaseModel.fields,
        compiled: attr({
            getDefault: () => ({
                polygon,
                size: attr(),
                fill: attr(),
                stroke: attr(),
                strokeWidth: attr(),
            }),
        }),
        type: attr({ getDefault: () => SEAT_TYPE_CIRCLE }),
        label: attr({ getDefault: () => singleLabel }),
        configuration: oneToOne('Configuration'),
        row: fk('Row'),
        roundTable: fk('RoundTable'),
        rectangleTable: fk('RectangleTable'),
        selected: attr({ getDefault: () => false }),
        objectType: attr({ getDefault: () => OBJECT_TYPE_SEAT }),
        enabled: attr({ getDefault: () => true }),
        purchaseStatus: attr({ getDefault: () => SEAT_PURCHASE_STATUS_FREE }),
        ticketType: fk('TicketType'),
        reservation: fk('Reservation'),
        forCashier: attr({ getDefault: () => false }),
        linkingPosition: attr({
            getDefault: () => ({
                sector: null,
                row: null,
                seat: null,
                roundTable: null,
                rectangleTable: null,
            }),
        }),
    };
}

export default Seat;
